import router from '@/router'
//import storage from "@/services/storage.js"

const app = {
    namespaced: true,

    state: {
        message: '',
        leftbar: null,
        menu: { link: '', tipo: '' },
        dialog: '',
        codeBar: '',
        articoloSelezionato: { codArticolo: '', prog: 0 },
        drawerMenu: false,
        azione: "",
        documentoLetto: ""
    },

    mutations: {

        showMessage(state, data) {
            state.message = data
        },


        setMenu(state, data) {
            state.menu = data
        },

        setMenuLink(state, data) {
            state.menu.link = data
        },

        setMenuTipo(state, data) {
            state.menu.tipo = data
        },

        setCodebar(state, data) {
            state.codeBar = data
        },

        setDialog(state, data) {
            state.dialog = data
        },

        setArticoloSelezionato(state, data) {
            state.articoloSelezionato = data

        },

        resetArticoloSelezionato(state, data) {
            state.articoloSelezionato.codArticolo = ""
            state.articoloSelezionato.prog = 0
        },

        apriDrawer(state, data) {
            state.drawerMenu = !state.drawerMenu
        },
        setDrawer(state, data) {
            state.drawerMenu = data;
        },

        setAzione(state, data) {
            state.azione = data;
        },

        setDocumentoLetto(state, data) {
            state.documentoLetto = data
        }
    },

    getters: {

        getCodebar(state) {
            return state.codeBar
        },

        getMenu(state) {
            return state.menu
        },
        getLink(state) {
            return state.menu.link
        },
        getTipo(state) {
            return state.menu.tipo
        },
        getDialog(state) {
            return state.dialog
        },
        getArticoloSelezionato(state) {
            return state.articoloSelezionato.codArticolo
        },
        getArticolo(state) {
            return state.articoloSelezionato
        },
        getDrawerMenu(state) {
            return state.drawerMenu
        },
        getAzione(state) {
            return state.azione
        },

        getUltimoDocumentoLetto(state) {
            return state.documentoLetto
        }
    },

    actions: {
        goto: ({ commit, getters }, par) => {

            let l = par.link;
            l += par.link != "/" && par.tipo ? "/" + par.tipo : "";

            router.push({ path: l });

        },

        impostaMenu: ({ commit }, par) => {
            // NOTA: quelli senza parametri metto stringa vuota x evitare di mettere undefined
            let p = par.params.tipo || "";

            // NOTA: ricavo il path senza parametri
            let l = p ? par.path.replace("/" + p, "") : par.path;

            commit("setMenu", {
                link: l,
                tipo: p
            });

            // Reset articolo
            commit("resetArticoloSelezionato", "");

        },

        impostaCodebar: ({ commit }, par) => {

            commit("setCodebar", par);

            // Reset articolo
            commit("resetArticoloSelezionato", "");

        }

    }


}

export default app